import { render } from "./StripePaymentForm.vue?vue&type=template&id=70b9e270"
import script from "./StripePaymentForm.vue?vue&type=script&lang=js"
export * from "./StripePaymentForm.vue?vue&type=script&lang=js"

import "./StripePaymentForm.vue?vue&type=style&index=0&id=70b9e270&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__